import script from "./AddonsMainItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddonsMainItem.vue?vue&type=script&setup=true&lang=ts"

import "./AddonsMainItem.vue?vue&type=style&index=0&id=207d3b83&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207d3b83"]])

export default __exports__